import React, { useContext, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Container, Form, Button, Message } from "semantic-ui-react";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import { IEmailConfig } from "../../../../app/models/company";
import { observer } from "mobx-react-lite";
import { toast } from "react-toastify";
import SelectInput from "../../../../app/common/form/SelectInput";
import {
  emailSendTypeOptions,
  getEmailSendTypeDescription,
} from "../../../../app/util/listOfValoursOptions";
import { EmailSendType } from "../../../../app/util/GeneralEnums";

// La descripcion se muestra debajo del selector, no dentro de cada opcion
const selectOptions = emailSendTypeOptions.map(({ key, text, value }) => ({ key, text, value }));

const EmailConfig = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const {
    supplier,
    btEmailConfigSupplier,
    updateEmailConfig,
  } = rootStore.companyStore;

  const [emailConfigForm] = useState<IEmailConfig>({
    emailSendType: supplier?.emailSendType ?? EmailSendType.AutomaticAndWithRequest,
  });

  const handleFinalFormSubmit = (values: IEmailConfig) => {
    if (emailConfigForm.emailSendType !== values.emailSendType) {
      updateEmailConfig(values);
    } else toast.error("No ha hecho ningún cambio");
  };
  return (
    <div className="tabContentStyle">
      <FinalForm
        initialValues={emailConfigForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit, values }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">
              <label>Envío de correo al adquiriente</label>
              <Field
                name="emailSendType"
                component={SelectInput}
                options={selectOptions}
              />
              <p>{getEmailSendTypeDescription(values.emailSendType)}</p>
              {values.emailSendType === EmailSendType.None && (
                <Message
                  warning
                  content="Con esta opción sus clientes no recibirán por correo las facturas ni los documentos electrónicos."
                />
              )}
              <br />
              <Button
                loading={btEmailConfigSupplier}
                disabled={btEmailConfigSupplier}
                className="ui primary button"
                color="blue"
                type="submit"
                content="Guardar"
              />
            </Container>
          </Form>
        )}
      />
    </div>
  );
};

export default observer(EmailConfig);
